////// Lib. //////
//////////////////

import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

///// Util. //////
//////////////////

import { isMobile } from "../../../../../../themes/wel-all/app/modules/DeviceDetection";

// Event hdls. ///
//////////////////

// ...

///// Assets /////
//////////////////

const msgs = {
  start: ["init. splide"],
  end: ["init. splide", "init. success"],
  no_el: ["init. splide", "no valid DOM el. provided"],
};

/// Init. def. ///
//////////////////

export default function init_splide() {
  ///// Setup //////
  //////////////////

  // const el_comp = this.element;
  const { wrpr_slides } = this.ref;
  const { logs } = this.options;
  if (logs) console.log(msgs.start[0]);

  ///// Init. //////
  //////////////////

  // Init. Splide instance
  if (wrpr_slides) {
    // const aspectRatio = 5 / 3.5;
    // const h_slide = "75vh";
    // const w_slide = `calc(${h_slide} * ${aspectRatio})`;
    new Splide(wrpr_slides, {
      type: "loop",
      focus: "center",
      drag: "free",
      // fixedWidth: w_slide,
      // fixedHeight: h_slide,
      fixedWidth: false,
      fixedHeight: false,
      autoWidth: true,
      autoHeight: true,
      gap: isMobile() ? "1.4rem" : "2rem",
      arrows: false,
      autoScroll: {
        speed: 0.45,
        pauseOnHover: false,
      },
    }).mount({ AutoScroll });
  }

  //// Conclude ////
  //////////////////

  if (logs) console.log(msgs.end[0], "→", msgs.end[1]);
}
